import { render, staticRenderFns } from "./Respondidas.vue?vue&type=template&id=36eb3e3e&"
import script from "./Respondidas.vue?vue&type=script&lang=js&"
export * from "./Respondidas.vue?vue&type=script&lang=js&"
import style0 from "./Respondidas.vue?vue&type=style&index=0&id=36eb3e3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports